// The editor HYDRATES ONCE per album: its pages, cover, and the last-writer
// baseline (`last_saved_at`, sent back as `expected_last_saved_at` on every
// autosave) all come from the first session it is handed. That session must
// come from a read the editor made AFTER it mounted.
//
// ⚠️ 2026-10-06 (#WA-402224, #1228): the cover picker and the editor share the
// query key ['session', order, album]. Pick a cover → the picker saves (the
// server's last_saved_at moves on) → the editor opens on the PICKER's cached
// copy, read before that save → its first autosave sends the old stamp → 409
// stale_write → « Cet album a été modifié ailleurs », autosave stops, and
// « Régénérer » looks broken. Nobody else had touched the album.
// `refetchOnMount: 'always'` did fetch the fresh row — but only after the
// one-shot hydration had already run on the old copy.
//
// Rule: until our own read lands, the editor sees NO session (the loading
// spinner stays up). If that read fails, the cached copy is used as before —
// better than a blank editor, and the server guard still refuses a save over
// newer work.
export interface SessionQueryState<T> {
  data: T | undefined;
  isLoading: boolean;
  isFetchedAfterMount: boolean;
}

export function freshSessionGate<T>(q: SessionQueryState<T>): { data: T | undefined; loading: boolean } {
  if (q.isFetchedAfterMount) return { data: q.data, loading: false };
  // A copy cached by another screen (cover picker, upload page) is not ours.
  return { data: undefined, loading: q.isLoading || q.data !== undefined };
}
